import 'scss/edit_caption.scss';
import axios from 'axios';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import t from 'tcomb-form';
import {URLS} from 'js/common';
import IconPencil from './icon_pencil';
import ContentType from './content_type';
import ContentSubmittedDate from './content_submitted_date';

const {Form} = t.form;

function formTemplate(locals) {
    return <div>{locals.inputs.caption}</div>;
}

const formOptions = {
    template: formTemplate,
    fields: {
        caption: {
            type: 'textarea',
            label: <label />,
            attrs: {
                className: 'caption-textarea',
                rows: 8
            }
        }
    }
};

class EditCaption extends Component {
    static propTypes = {
        preSubmit: PropTypes.func,
        postSubmit: PropTypes.func,
        caption: PropTypes.string.isRequired,
        metaDataId: PropTypes.number.isRequired,
        showEditButton: PropTypes.bool,
        isCaptionEditable: PropTypes.bool,
        contentSnTypeId: PropTypes.string,
        contentSnType: PropTypes.string,
        contentCreatedAt: PropTypes.string
    };

    static defaultProps = {
        preSubmit: () => {},
        postSubmit: () => {},
        showEditButton: false,
        isCaptionEditable: true
    };

    constructor(props) {
        super(props);

        this.state = {
            showTextArea: false,
            showEditButton: props.showEditButton,
            isCaptionEditable: props.isCaptionEditable,
            formData: {
                caption: props.caption
            }
        };

        const captionRefinement = t.maybe(t.String);

        this.contentSubmitFormType = t.struct({
            caption: captionRefinement
        });
    }

    /**
     * @param {{caption: string}} nextProps
     * @memberof EditCaption
     */
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.caption !== this.props.caption) {
            this.setState({
                formData: {
                    ...this.state.formData,
                    caption: nextProps.caption
                }
            });
        }
    }

    handleCancelCaption = () => {
        this.setState({
            showTextArea: false,
            formData: {
                caption: this.props.caption
            }
        });
    };

    handleContentFormChange = formData => {
        this.setState({
            formData
        });
    };

    toggleShowTextArea = () => {
        this.setState({
            showTextArea: !this.state.showTextArea
        });
    };

    handleUpdateCaption = async () => {
        const {formData} = this.state;
        const {preSubmit, postSubmit} = this.props;
        event.preventDefault();
        preSubmit();

        const {update_content_metadata_caption} = URLS;
        const {metaDataId} = this.props;
        const fullUrl = update_content_metadata_caption.replace(
            '__CONTENT_METADATA_ID__',
            metaDataId
        );

        try {
            await axios.post(fullUrl, formData);
        } catch (error) {
            // TODO: add UI to display error to user
        }
        postSubmit();

        this.toggleShowTextArea();
    };

    renderEditButton = () => {
        const {showEditButton, isCaptionEditable, showTextArea} = this.state;

        let buttonStyles;
        if (showTextArea) {
            buttonStyles = {backgroundColor: '#E1E5E8', cursor: 'default'};
        } else if (!showEditButton) {
            buttonStyles = {display: 'none'};
        }

        return (
            <button
                style={buttonStyles}
                className="caption-edit"
                disabled={showTextArea || !isCaptionEditable}
                onClick={this.toggleShowTextArea}
            >
                <IconPencil />
                Edit
            </button>
        );
    };

    render() {
        const {formData} = this.state;

        const captionArea = this.state.showTextArea ? null : (
            <div className="caption-content">{formData.caption}</div>
        );

        const textArea = (
            <div className="caption-form">
                {this.props.children}
                <Form
                    ref="form"
                    value={formData}
                    onChange={this.handleContentFormChange}
                    options={formOptions}
                    type={this.contentSubmitFormType}
                />
                <div className="activity-area">
                    <div className="approval-actions">
                        <button className="reject" onClick={this.handleCancelCaption}>
                            Cancel
                        </button>
                        <button onClick={this.handleUpdateCaption} className="approve">
                            Save Caption
                        </button>
                    </div>
                </div>
            </div>
        );

        return (
            <div className="caption-container">
                <div className="caption-header">
                    <div className="caption-edit-container">
                        Caption
                        {this.renderEditButton()}
                    </div>


                    <div className="content-row__details">
                        <div className="content-row__details-item">
                            {this.props.contentSnType && this.props.contentSnTypeId ? (
                                <ContentType
                                    value={this.props.contentSnType}
                                    id={this.props.contentSnTypeId}
                                />
                            ) : null}
                        </div>

                        {!!this.props.contentCreatedAt && (
                            <div className="content-row__details-item">
                                <ContentSubmittedDate date={this.props.contentCreatedAt} />
                            </div>
                        )}
                    </div>
                </div>
                {captionArea}
                <div>{this.state.showTextArea ? textArea : null}</div>
            </div>
        );
    }
}

export default EditCaption;



// WEBPACK FOOTER //
// ./components/edit_caption.js